module.exports = __webpack_public_path__ + "static/media/membership-member-subscription-id-card-svgrepo-com.2341f00a.svg";